import React, { Fragment } from 'react';
import { func, bool, array, object } from 'prop-types';

import DropZone from './drop-zone';
import AttachmentsList from './list/';
import { Spinner } from '../ui-helpers/';
import AttachmentsHeader from './header/';
import { Wrapper, AttachmentsWrap } from './styled-components';


const Attachments = (props) => {
  const {
    onDrop,
    isLoading,
    attachments,
    minView,
    wrapperStyles,
    openFilePicker,
    onAttachmentRemove,
    onAttachmentsAdd,
  } = props;

  const hideHeader = (minView && attachments.length === 0);

  return (
    <Wrapper style={wrapperStyles}>
      <DropZone onDrop={onDrop}>
        <Fragment>
          <AttachmentsHeader {...{ hideHeader, minView }} {...props} />

          <AttachmentsWrap>
            {isLoading && <Spinner />}

            <AttachmentsList
              {...{
                attachments,
                minView,
                openFilePicker,
                onAttachmentRemove,
                isLoading,
                onAttachmentsAdd,
              }}
            />
          </AttachmentsWrap>
        </Fragment>
      </DropZone>
    </Wrapper>
  );
};

Attachments.propTypes = {
  isLoading: bool,
  openFilePicker: func,
  wrapperStyles: object,
  onAttachmentsAdd: func,
  onDrop: func.isRequired,
  onAttachmentRemove: func,
  attachments: array.isRequired,
  minView: bool,
};

Attachments.defaultProps = {
  isLoading: false,
  wrapperStyles: {},
  minView: false,
  openFilePicker: null,
  onAttachmentsAdd: null,
  onAttachmentRemove: null,
};

export default Attachments;



// WEBPACK FOOTER //
// ./src/components/attachments/index.js